import { Navigate, useParams } from 'react-router-dom';

export const ProducerRedirect = () => {
  const { handle } = useParams();
  return <Navigate to={`/${handle}`} />;
};
